import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppContext } from "../../../../context/AppContext";
//primer react
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import { confirmDialog } from "primereact/confirmdialog";
import { TabPanel, TabView } from "primereact/tabview";
//Pages
import Finance from "./Finance";
import Cancellation from "./Cancellation";
import EditEnterprise from "./EditEnterprise";
import OwnerEdit from "./OwnersEdit";
//components
import Panel from "../../../../components/panel/panel";
//services
import { getOneEnterprise } from "../../../../services/Enterprise/getOneEnterprise";
import { deleteEnterprise } from "../../../../services/Enterprise/deleteEnterprise";
import Documents from "./Documents";
import { queryClient } from "../../../../utils/queryClient";
import usePermission from "../../../../hooks/usePermission";
import CenterCostLink from "./CenterCostLink";

export default function EnterpriseDetails() {
  usePermission("105"); // Editar Informações do Empreendimento
  const { id } = useParams(); //get id
  const { state } = useLocation();
  const { permissions } = useAppContext();
  const navigate = useNavigate();

  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const items = [
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Empreendimento
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/enterpriseDetails/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          {state ? state.name : "Empreendimento"}
        </Link>
      ),
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const fetchOneEnterprise = async (code) => {
    const response = await getOneEnterprise(code);
    return response;
  };

  const { data: oneEnterprise, isLoading: loadingEnterprise } = useQuery({
    queryKey: [`oneEnterprise${id}`],
    queryFn: () => fetchOneEnterprise(id),
    enabled: !!permissions?.includes("13"),

  });

  const confirmDelete = () => {
    confirmDialog({
      message: "Deseja excluir o Empreendimento?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => enterpriseDelete(id),
    });
  };

  const enterpriseDelete = async (id) => {
    const notification = toast.loading("Aguarde..");
    try {
      const response = await deleteEnterprise(id);
      queryClient.setQueryData([`enterprise`], (data) => {
        const updatedFiles = data?.filter((item) => item.id !== parseInt(id));
        return updatedFiles;
      });
      toast.update(notification, {
        render: response.success,
        type: "success",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
      navigate("/salesManagement");
    } catch (e) {
      toast.update(notification, {
        render: e.response.data.error,
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    }
  };

  useEffect(() => {
    if (state.index >= 0) {
      setActiveIndex(state.index);
    }
  }, [state])

  return (
    <>
      <div className="row mb-3">
        <div className="col-md-9">
          <BreadCrumb
            model={items}
            home={home}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
            }}
          />
        </div>
        {permissions && permissions.includes("108") && ( // Deletar Empreendimento
          <div className="col-md-3">
            <Button
              rounded
              severity="danger"
              label="Deletar Empreendimento"
              icon="fa fa-trash-can"
              onClick={() => confirmDelete()}
              className="p-inputtext-sm me-2 m-auto w-100"
            />
          </div>
        )}
      </div>

      <Panel title="Configurações do Empreendimento">
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className="meu-tabview pt-3"
        >
          {permissions && permissions.includes("105") && ( // Editar Informações do Empreendimento
            <TabPanel header="Editar Empreendimento" leftIcon="pi pi-pencil mx-2">
              <EditEnterprise
                id={id}
                setActiveIndex={setActiveIndex}
                oneEnterprise={oneEnterprise}
                loadingEnterprise={loadingEnterprise}
              />
            </TabPanel>
          )}
            {permissions && permissions.includes("105") && ( // Editar Proprietarios do Empreendimento
            <TabPanel header="Proprietarios" leftIcon="pi pi-users mx-2">
              <OwnerEdit id={id} />
            </TabPanel>
          )}

          {permissions && permissions.includes("106") && ( // Editar Financeiro do Empreendimento
            <TabPanel header="Financeiro" leftIcon="pi pi-dollar mx-2">
              <Finance id={id} state={state} setActiveIndex={setActiveIndex} />
            </TabPanel>
          )}
          {permissions && permissions.includes("107") && ( // Editar Distrato do Empreendimento
            <TabPanel header="Distrato" leftIcon="pi pi-file-excel mx-2">
              <Cancellation id={id} setActiveIndex={setActiveIndex} />
            </TabPanel>
          )}
          {permissions && permissions.includes("58") && ( // Visualizar Anexos
            <TabPanel header="Anexo de Arquivos" leftIcon="pi pi-tag mx-2">
              <Documents />
            </TabPanel>
          )}
            {permissions && permissions.includes("180") && ( // Visualizar Vinculo de Centro de Custo
            <TabPanel header="Centro de Custo" leftIcon="pi pi-file mx-2">
              <CenterCostLink />
            </TabPanel>
          )}

          
        </TabView>
      </Panel>
    </>
  );
}
